import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FourohfourComponent } from '@core/pages/fourohfour/fourohfour.component';

const routes: Routes = [
  {
    path: '**',
    component: FourohfourComponent,
    data: { title: 'Page not found' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class WildcardRoutingModule {}
